import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Magnetic } from "./Reveal";
import { AUDIENCE_LINKS, CONTACT, NAV_LINKS } from "../data/content";

export const Footer = () => (
  <footer className="relative bg-surface border-t border-line text-ink overflow-hidden" data-testid="footer">
    <img
      src="/images/wappen.png"
      alt=""
      aria-hidden="true"
      className="absolute -left-20 bottom-0 h-[480px] w-auto opacity-[0.05] pointer-events-none select-none hidden md:block"
    />
    <div className="container-x pt-20 md:pt-24 relative">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pb-12">
        <div className="flex flex-col sm:flex-row sm:items-center gap-6 order-2 lg:order-1">
          <img src="/images/logo-komposition.png" alt="Manfred Berglar – Zunftwappen mit Wortmarke, Meisterbetrieb seit 1925" className="h-16 sm:h-20 w-auto shrink-0 self-start" />
          <p className="text-muted max-w-md min-w-0 leading-relaxed text-sm">
            Malerarbeiten, Fassaden und Oberflächen für Privatkunden, Unternehmen und Kommunen – Meisterbetrieb
            seit 1925 in Olpe-Griesemert.
          </p>
        </div>
        <Magnetic strength={16} className="self-start order-1 lg:order-2">
          <Link to="/kontakt" data-testid="footer-cta" className="btn-primary">
            Projekt anfragen <ArrowUpRight size={16} />
          </Link>
        </Magnetic>
      </div>
      <p
        data-testid="footer-brandtype"
        aria-hidden="true"
        className="font-display font-extrabold tracking-tight leading-[0.9] text-ink/[0.05] select-none text-[clamp(2.5rem,7.6vw,8.5rem)] whitespace-nowrap overflow-hidden text-center"
      >
        Manfred Berglar
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 py-12 text-sm border-t border-line">
        <div>
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase font-extrabold text-golddark mb-4">Kontakt</p>
          <p className="text-ink/70 leading-relaxed">
            {CONTACT.owner}<br />
            {CONTACT.street}<br />
            {CONTACT.city}
          </p>
        </div>
        <div>
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase font-extrabold text-golddark mb-4">Direkt</p>
          <p className="flex flex-col gap-2">
            <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              {CONTACT.phoneDisplay}
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              {CONTACT.email}
            </a>
          </p>
        </div>
        <div>
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase font-extrabold text-golddark mb-4">Zielgruppen</p>
          <nav className="flex flex-col gap-0.5">
            {AUDIENCE_LINKS.map((l) => (
              <Link key={l.id} to={l.to} data-testid={`footer-audience-${l.id}`} className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div>
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase font-extrabold text-golddark mb-4">Navigation</p>
          <nav className="flex flex-col gap-0.5">
            {NAV_LINKS.map((l) => (
              <Link key={l.id} to={l.to} data-testid={`footer-nav-${l.id}`} className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
                {l.label}
              </Link>
            ))}
            <Link to="/kontakt" data-testid="footer-nav-kontakt" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              Kontakt
            </Link>
          </nav>
        </div>
        <div>
          <p className="font-sans text-[11px] tracking-[0.22em] uppercase font-extrabold text-golddark mb-4">Rechtliches</p>
          <div className="flex flex-col gap-0.5">
            <Link to="/impressum" data-testid="footer-impressum-link" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              Impressum
            </Link>
            <Link to="/agb" data-testid="footer-agb-link" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              AGB
            </Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300">
              Datenschutz
            </Link>
            <button
              onClick={() => window.dispatchEvent(new Event("berglar:open-consent"))}
              data-testid="footer-cookie-settings"
              className="inline-block py-3 text-ink/70 hover:text-golddark transition-colors duration-300 text-left"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
      <div className="border-t border-line py-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted">
        <p>© 2026 Manfred Berglar · Malermeister seit 1925. Alle Rechte vorbehalten.</p>
        <p className="font-mono tracking-[0.2em] uppercase">Stadt Olpe · Südsauerland · Seit 1925</p>
      </div>
    </div>
  </footer>
);
